class AssignedTaskModel {
    constructor(taskLocation = []) {
        this.taskLocation = taskLocation;
    }

    static fromJSON(json) {
        return new AssignedTaskModel(
            json.task_location?.map((item) => TaskLocation.fromJSON(item)) || []
        );
    }

    toJSON() {
        return {
            task_location: this.taskLocation?.map((item) => item.toJSON()) || [],
        };
    }
}

class TaskLocation {
    constructor({
                    driverImageUrl = null,
                    driverId = null,
                    driverName = null,
                    driverEmail = null,
                    assignedLocationCount = null,
                    selectedVehicleDetails = null,
                    tasks = [],
                } = {}) {
        this.driverImageUrl = driverImageUrl;
        this.driverId = driverId;
        this.driverName = driverName;
        this.driverEmail = driverEmail;
        this.assignedLocationCount = assignedLocationCount;
        this.selectedVehicleDetails = selectedVehicleDetails
            ? SelectedVehicleDetails.fromJSON(selectedVehicleDetails)
            : null;
        this.tasks = tasks.map((task) => Tasks.fromJSON(task));
    }

    static fromJSON(json) {
        return new TaskLocation({
            driverImageUrl: json.driver_image_url,
            driverId: json.driver_id,
            driverName: json.driver_name,
            driverEmail: json.driver_email,
            assignedLocationCount: json.assigned_location_count,
            selectedVehicleDetails: json.selected_vehicle_details,
            tasks: json.tasks || [],
        });
    }

    toJSON() {
        return {
            driver_image_url: this.driverImageUrl,
            driver_id: this.driverId,
            driver_name: this.driverName,
            driver_email: this.driverEmail,
            assigned_location_count: this.assignedLocationCount,
            selected_vehicle_details: this.selectedVehicleDetails?.toJSON() || null,
            tasks: this.tasks.map((task) => task.toJSON()),
        };
    }
}

class SelectedVehicleDetails {
    constructor(vehicleId = null, vehicleName = null) {
        this.vehicleId = vehicleId;
        this.vehicleName = vehicleName;
    }

    static fromJSON(json) {
        return new SelectedVehicleDetails(json.vehicle_id, json.vehicle_name);
    }

    toJSON() {
        return {
            vehicle_id: this.vehicleId,
            vehicle_name: this.vehicleName,
        };
    }
}

class Tasks {
    constructor({
                    taskId = null,
                    createdDate = null,
                    updatedDate = null,
                    locationId = null,
                    address = null,
                    visitTime = null,
                    vendorName=null,
                    clientLocation = null,
                    destinationHubLocationId = null,
                    destinationHubLocationName = null,
                    originHubLocationId = null,
                    originHubLocationName = null,
                    tasksType = [],
                    status = null,
                    displayName = null,
                    taskAge = null, 
                } = {}) {
        this.taskId = taskId;
        this.createdDate = createdDate;
        this.updatedDate = updatedDate;
        this.locationId = locationId;
        this.address = address;
        this.visitTime = visitTime;
        this.vendorName=vendorName||"-";
        this.clientLocation = clientLocation;
        this.destinationHubLocationId = destinationHubLocationId;
        this.destinationHubLocationName = destinationHubLocationName;
        this.originHubLocationId = originHubLocationId;
        this.originHubLocationName = originHubLocationName;
        this.tasksType = tasksType.map((type) => TasksType.fromJSON(type));
        this.status = status;
        this.displayName = displayName;
        this.taskAge = taskAge;
    }

    static fromJSON(json) {
        return new Tasks({
            taskId: json.task_id,
            createdDate: json.created_date,
            updatedDate: json.updated_date,
            locationId: json.location_id,
            address: json.address,
            visitTime: json.visit_time,
            vendorName:json.vendor_name,
            clientLocation: json.client_location,
            destinationHubLocationId: json.destination_hub_location_id,
            destinationHubLocationName: json.destination_hub_location_name,
            originHubLocationId: json.origin_hub_location_id,
            originHubLocationName: json.origin_hub_location_name,
            tasksType: json.tasks_type || [],
            status: json.status,
            displayName: json.display_name,
            taskAge: json.task_age || null
        });
    }

    toJSON() {
        return {
            task_id: this.taskId,
            created_date: this.createdDate,
            updated_date: this.updatedDate,
            location_id: this.locationId,
            address: this.address,
            visit_time: this.visitTime,
            vendor_name: this.vendorName,
            client_location: this.clientLocation,
            destination_hub_location_id: this.destinationHubLocationId,
            destination_hub_location_name: this.destinationHubLocationName,
            origin_hub_location_id: this.originHubLocationId,
            origin_hub_location_name: this.originHubLocationName,
            tasks_type: this.tasksType.map((type) => type.toJSON()),
            status: this.status,
            display_name: this.displayName,
            task_age: this.taskAge,
        };
    }
}

class TasksType {
    constructor(taskId = null, type = null, count = null, concept = null) {
        this.taskId = taskId;
        this.type = type;
        this.count = count;
        this.concept = concept;
    }

    static fromJSON(json) {
        return new TasksType(json.task_id, json.type, json.count, json.concept);
    }

    toJSON() {
        return {
            task_id: this.taskId,
            type: this.type,
            count: this.count,
            concept: this.concept,
        };
    }
}

export {AssignedTaskModel};